import {
  TextInput,
  required,
  useTranslate,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { Typography } from "@material-ui/core";
import { RESOURCE_NAME_ORG_STRUCTURE_TYPES } from "./constants";
import { MAX_RECORDS_PER_PAGE } from "../../../../lib/common";

export const styles: Styles<Theme, any> = {
  number: { display: "block" },
  name: { display: "block" },
  description: { display: "block" },
  formClass: {
    width: "75%",
  },
};
const useStyles = makeStyles(styles);

const OrgStructureTypesForm = ({ isEdit = false, ...rest }) => {
  const classes = useStyles(rest);
  return (
    <SimpleForm
      variant="filled"
      className={classes.formClass}
      warnWhenUnsavedChanges
      {...rest}
    >
      <SectionTitle label="resources.OrgStructureTypes.fieldGroups.OrgStructureTypesDetaills" />
      <TextInput
        autoFocus
        source="number"
        label="resources.OrgStructureTypes.fields.number"
        helperText="resources.OrgStructureTypes.help.number"
        formClassName={classes.number}
        validate={[required()]}
        fullWidth
      />

      <TextInput
        source="name"
        label="resources.OrgStructureTypes.fields.name"
        helperText="resources.OrgStructureTypes.help.name"
        formClassName={classes.name}
        validate={[required()]}
        fullWidth
      />

      <RichTextInput
        source="description"
        helperText="resources.OrgStructureTypes.help.description"
        formClassName={classes.description}
        label="resources.OrgStructureTypes.fields.description"
      />
      <ReferenceInput
        source="parentId"
        label="resources.OrgStructureTypes.fields.parentId"
        fullWidth
        reference={RESOURCE_NAME_ORG_STRUCTURE_TYPES}
        perPage={MAX_RECORDS_PER_PAGE}
        sort={{ field: "name", order: "ASC" }}
        filter={isEdit ? { excludeIds: [rest?.id] } : {}}
        key="parentId"
      >
        <AutocompleteInput
          optionText="displayLabel"
          helperText="resources.OrgStructureTypes.help.parentId"
          resettable={true}
          allowEmpty={true}
        />
      </ReferenceInput>
    </SimpleForm>
  );
};
const SectionTitle = ({ label }: { label: string }) => {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {translate(label)}
    </Typography>
  );
};

export { OrgStructureTypesForm };
